import React from "react";
import OwlCarousel from "react-owl-carousel";
import "../../../assets/styles/main.css";
import "../../../assets/styles/responsive.css";
import images from "../../../Utilities";
import TestimonialSliderItem from "./TestimonialSliderItem";
const testimonials = [
  {
    dp: "https://randomuser.me/api/portraits/women/45.jpg",
    userName: "Naomi Allen",
    companyName: "Brightline",
    review:
      "LeadBud took care of our video labeling needs with a 98% accuracy rate, reviewing over 350 video events per hour. Their adaptability to our evolving products and software showcases their exceptional project management and leadership.",
  },
  {
    dp: "https://randomuser.me/api/portraits/men/50.jpg",
    userName: "Ed Park",
    companyName: "Devoted Health",
    review:
      "Over the past year, our team with LeadBud has grown from 4 to over 30 agents. They now support our social media platforms, email, and text message support, leading to our highest customer satisfaction ratings ever.",
  },
  {
    dp: "https://randomuser.me/api/portraits/men/55.jpg",
    userName: "Andres Otero",
    companyName: "IPCOM",
    review:
      "LeadBud excels in lead generation, providing competent sales personnel for initial lead collection. They were punctual, attentive to our specific requirements, and crafted a tailored solution for us.",
  },
  {
    dp: "https://randomuser.me/api/portraits/women/60.jpg",
    userName: "Geraldine Salcedo",
    companyName: "Intemporel New York",
    review:
      "LeadBud integrated seamlessly with our corporate culture and goals, making them a committed partner rather than just an external agency. Their unmatched expertise in email marketing and their responsiveness have been crucial to our collaboration.",
  },
];

const options = {
  dots: false,
  responsiveClass: true,
  loop: true,
  autoplay: true,
  smartSpeed: 300,
  autoplayTimeout: 2000,
  nav: true,
  navText: [
    '<i class="fa-solid fa-arrow-left"></i>',
    '<i class="fa-solid fa-arrow-right"></i>',
  ],
  responsive: {
    0: { items: 1 },
    992: { items: 1.5 },
    1200: { items: 2.5 },
  },
};

const LandingPageTestimonial = () => {
  return (
    <div
      className="section home-testimonials"
      style={{
        backgroundImage: `url('${images.LandingPageTestimonial}')`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        paddingTop: "188px",
        paddingBottom: "80px",
      }}
    >
      <div className="container-fluid">
        <div className="content-area padding-left">
          <h2>What Other Customers Say About LeadBud</h2>
        </div>

        <OwlCarousel className="owl-carousel padding-left" {...options}>
          {testimonials.map((item, i) => (
            <TestimonialSliderItem
              key={i}
              userDP={item.dp}
              userName={item.userName}
              companyName={item.companyName}
              review={item.review}
            />
          ))}
        </OwlCarousel>
      </div>
    </div>
  );
};

export default LandingPageTestimonial;
